const actions = {
  GET_HOURLY_REPORT_LOAD: 'GET_HOURLY_REPORT_LOAD',
  GET_HOURLY_REPORT_SUCCESS: 'GET_HOURLY_REPORT_SUCCESS',
  GET_HOURLY_REPORT_ERROR: 'GET_HOURLY_REPORT_ERROR',

  getHourlyReportLoad: () => {
    return { type: actions.GET_HOURLY_REPORT_LOAD };
  },
  getHourlyReportSuccess: (hourReport) => {
    return { type: actions.GET_HOURLY_REPORT_SUCCESS, hourReport };
  },
  getHourlyReportErr: (err) => {
    return { type: actions.GET_HOURLY_REPORT_ERROR, err };
  },
};

export default actions;
